import { render, staticRenderFns } from "./signUpDetail.vue?vue&type=template&id=e10b606e&scoped=true&"
import script from "./signUpDetail.vue?vue&type=script&lang=ts&"
export * from "./signUpDetail.vue?vue&type=script&lang=ts&"
import style0 from "./signUpDetail.vue?vue&type=style&index=0&id=e10b606e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10b606e",
  null
  
)

export default component.exports